export const BILLING_ADDRESS_COUNTRY = 'billing_address.country';
export const BILLING_ADDRESS_STATE = 'billing_address.state';
export const BILLING_ADDRESS_STATES = 'billing_address.states';
